import { Directive,InjectionToken, Input, HostBinding } from '@angular/core';
import { NgModel } from '@angular/forms';


export const ICardComponentInjectionToken = new InjectionToken('CardComponent');

@Directive({
    selector: '[radioLabel]',
    standalone: false
})
export class RadioLabelDirective {

  
  @Input('radioLabel') control: NgModel;
  //TODO : Implementar também o set da classe ativo na label, mas precisa de ser visto com mais tempo proque o control
  //aparente tar apenas a trazer o valor do ultimo radiobutton
  //renderizado(por estar dentro de um for deve etstar a dar override a templatereferencevariable )
  @HostBinding('class.ng-touched')
  public get isTouched() { return this.control?.touched;  }
  @HostBinding('class.ng-invalid')
  public get isInvalid() { return this.control?.invalid; }

  constructor() {
  }
}
